import React from "react";
import "./Style/Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      Developer:<strong> Arghya Ghosh</strong>
    </div>
  );
}
